"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Buttons = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _api = require("../../../../api");
var _contexts = require("../../../../contexts");
var _hooks = require("../../../../hooks");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const Buttons = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    productCode,
    reviewId,
    onClose: onRatingAndReviewDialogClose
  } = (0, _contexts.useRatingAndReviewDialog)();
  const {
    open,
    onClose: onDeleteConfirmDialogClose,
    onOpen: onDeleteConfirmDialogOpen
  } = (0, _presentationHooks.useDisclose)();
  const deleteReview = (0, _api.useDeleteReview)({
    onDeleteConfirmDialogClose
  });
  const {
    formState: {
      disabled,
      errors,
      isSubmitting,
      isSubmitSuccessful
    }
  } = (0, _contexts.useRatingAndReviewForm)();
  const submitting = disabled || isSubmitting || isSubmitSuccessful;
  const actions = (0, _react.useMemo)(() => [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
    fullWidth: true,
    color: "error",
    variant: "contained",
    maxWidth: "330px",
    onClick: deleteReview,
    children: translations.delete
  }, "delete"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
    fullWidth: true,
    color: "default",
    variant: "text",
    maxWidth: "330px",
    onClick: onDeleteConfirmDialogClose,
    children: translations.cancel
  }, "cancel")], [deleteReview, onDeleteConfirmDialogClose, translations.cancel, translations.delete]);
  if (!productCode && !reviewId) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
    "data-testid": getTestId(_constants.BUTTONS),
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 3,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      fullWidth: true,
      "data-testid": getTestId(_constants.SUBMIT_BUTTON),
      maxWidth: "330px",
      variant: "contained",
      color: "primary",
      loading: submitting,
      type: "submit",
      children: reviewId ? translations.save : translations.submit
    }), Object.keys(errors).length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      maxWidth: 330,
      width: "100%",
      color: "error",
      textAlign: "left",
      children: translations.missingRequiredData
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      fullWidth: true,
      "data-testid": getTestId(_constants.CANCEL_BUTTON),
      maxWidth: "330px",
      variant: reviewId ? 'outlined' : 'text',
      color: "default",
      disabled: submitting,
      onClick: onRatingAndReviewDialogClose,
      children: reviewId ? translations.discard : translations.cancel
    }), reviewId ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      "data-testid": getTestId(_constants.DELETE_BUTTON),
      variant: "text",
      color: "error",
      size: "small",
      startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.TrashcanFilled, {}),
      disabled: submitting,
      onClick: onDeleteConfirmDialogOpen,
      children: translations.delete
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.FeedbackDialog, {
      fullWidth: true,
      "data-testid": getTestId(_constants.DELETE_CONFIRMATION_DIALOG),
      actions: actions,
      header: translations.delete,
      maxWidth: "450px",
      open: open,
      severity: "error",
      onClose: onDeleteConfirmDialogClose,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        textAlign: "left",
        children: translations.deleteConfirmDescription
      })
    })]
  });
};
exports.Buttons = Buttons;
